import { Layout } from 'components/layout';
import { cn } from 'lib/utils';
import { useMemo, useState } from 'react';
import { ApartsmentLayoutsItem, Flat } from '../apartsment-layouts-item/apartsment-layouts-item';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../carousel/carousel';

const apartmentsList: Flat[] = [
  {
    image: '/assets/images/apartments/23,85.png',
    title: 'Студия, 23,85 м²',
    price: 'От 5,8 млн руб',
    oldPrice: 'от 7,7 млн руб',
    commonSpace: '23,85 м²',
    livingSpace: '12,3 м²',
    dialogTitle: 'Студия',
    firstText: "Скидка 25%",
    priceNumber: 5814630,
    oldPriceNumber: 7751250,
    secondText: "Без отделки"
  },
  {
    image: '/assets/images/apartments/1_31,53.png',
    title: '1-комнатная, 31,53 м²',
    price: 'от 6,9 млн руб',
    oldPrice: 'от 9,3 млн руб',
    commonSpace: '31,53 м²',
    livingSpace: '12,20 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 6952365,
    oldPriceNumber: 9269820,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/40_57.png',
    title: '2-комнатная (евро) , 40,57 м²',
    price: 'От 8,1 млн руб.',
    oldPrice: 'от 10,7 млн руб',
    commonSpace: '40,57 м²',
    livingSpace: '24,98 м²',
    dialogTitle: 'Двухкомнатная квартира (евро)',
    firstText: "Скидка 25%",
    priceNumber: 8065316,
    oldPriceNumber: 10751050,
    secondText: "Без отделки"
  },
  {
    image: '/assets/images/apartments/56,94.png',
    title: '2-комнатная, 56,94 м²',
    price: 'От 10,8 млн руб.',
    oldPrice: 'от 14,3 млн руб',
    commonSpace: '56,94 м²',
    livingSpace: '35,39 м²',
    dialogTitle: 'Двухкомнатная квартира',
    firstText: "Скидка 25%",
    priceNumber: 10761660,
    oldPriceNumber: 14348880,
    secondText: "Без отделки"
  },
  {
    image: '/assets/images/apartments/60_76.png',
    title: '3-комнатная (евро), 60,76 м²',
    price: 'От 11,5 млн руб.',
    oldPrice: 'от 15,3 млн руб',
    commonSpace: '60,76 м²',
    livingSpace: '39,69 м²',
    dialogTitle: 'Трехкомнатная квартира',
    firstText: "Скидка 25%",
    priceNumber: 11483640,
    oldPriceNumber: 15311520,
    secondText: "Без отделки"
  },
  {
    image: '/assets/images/apartments/4с_60,76.png',
    title: '3-комнатная, 64,12 м²',
    price: 'От 12,1 млн руб.',
    oldPrice: 'от 16,1 млн руб',
    commonSpace: '64,12 м²',
    livingSpace: '41,76 м²',
    dialogTitle: 'Трехкомнатная квартира',
    firstText: "Скидка 25%",
    priceNumber: 12118680,
    oldPriceNumber: 16158240,
    secondText: "Без отделки"
  },
];

const apartmentsFirstSecondList: Flat[] = [
  {
    image: "/assets/images/apartments/first-second/st/18-20.jpg",
    title: "Студия, 18,2 м²",
    price: "от 5,0 млн руб",
    oldPrice: "от 7,1 млн руб",
    commonSpace: "18,2 м²",
    livingSpace: "8,01 м²",
    dialogTitle: "Студия",
    firstText: "Скидка 30%",
    priceNumber: 4968600,
    oldPriceNumber: 7098000
  },
  {
    image: "/assets/images/apartments/first-second/1k/34-33.jpg",
    title: "Однокомнатная квартира, 34,33 м²",
    price: "от 6,5 млн руб",
    oldPrice: "от 9,3 млн руб",
    commonSpace: "34,33 м²",
    livingSpace: "11,9 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 6488370,
    oldPriceNumber: 9269100
  },
  {
    image: "/assets/images/apartments/first-second/2e/37-40.jpg",
    title: "2-комнатная квартира (евро), 37,4 м²",
    price: "от 6,8 млн руб",
    oldPrice: "от 9,7 млн руб",
    commonSpace: "37,4 м²",
    livingSpace: "26,77 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 6806800,
    oldPriceNumber: 9724000
  },
  {
    image: "/assets/images/apartments/first-second/3e/55-93.jpg",
    title: "3-комнатная квартира (евро), 55,93 м²",
    price: "от 9,6 млн руб",
    oldPrice: "от 13,7 млн руб",
    commonSpace: "55,93 м²",
    livingSpace: "39,57 м²",
    dialogTitle: "Трёхкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 9631146,
    oldPriceNumber: 13758780
  },
  {
    image: "/assets/images/apartments/first-second/3k/74-58.jpg",
    title: "3-комнатная квартира, 74,58 м²",
    price: "от 12,8 млн руб",
    oldPrice: "от 18,3 млн руб",
    commonSpace: "74,58 м²",
    livingSpace: "47,17 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 12842676,
    oldPriceNumber: 18346680
  }
];

const apartments = {
  "1, 2 корпус": apartmentsFirstSecondList,
  "3 корпус": apartmentsList
}

export const ApartmentLayouts = () => {
  const [selectTab, setSelectedTab] = useState<keyof typeof apartments>("1, 2 корпус");

  const filterButtons = useMemo(() => {
    return Object.keys(apartments).map((m, index, arr) => (
      <button
        key={index.toString() + m}
        onClick={() => {
          if (arr.includes(m)) {
            setSelectedTab(m as keyof typeof apartments)
          }
        }}
        className={cn(
          'text-plt-black font-semibold px-[15px] py-1.5 bg-[#B4B4B4] rounded-full',
          m === selectTab &&
          'bg-plt-black text-plt-white'
        )}
      >
        <span className="">{m}</span>
      </button>
    ))
  }, [selectTab])
  return (
    <section
      className="bg-plt-secondary/50 pt-[72px] pb-[48px] font-open-sans screen-900:pt-6 screen-900:bg-plt-white screen-900:pb-0">
      <Layout.Container>
        <div className="bg-plt-white rounded-[40px] pt-10 pb-[52px] screen-900:rounded-none">
          <h3 className="uppercase font-bold text-center text-[32px] text-plt-black screen-700:text-lg">
            БОЛЬШОЙ ВЫБОР ПЛАНИРОВОЧНЫХ РЕШЕНИЙ
          </h3>
          <div className="flex justify-center mt-5 gap-5">
            {filterButtons}
          </div>
          {/*<div className="mt-16 grid grid-cols-5 gap-4 px-[33px] screen-1150:hidden">*/}
          {/*  {apartmentsList.map((apartment) => (*/}
          {/*    <ApartsmentLayoutsItem*/}
          {/*      key={apartment.title}*/}
          {/*      apartment={apartment}*/}
          {/*    />*/}
          {/*  ))}*/}
          {/*</div>*/}
          <div className="px-[66px] mt-4">
            <Carousel key={selectTab} opts={{ align: 'start', loop: true }}>
              <CarouselContent>
                {apartments[selectTab].map((apartment) => (
                  <CarouselItem
                    key={apartment.title}
                    className="basis-1/5 screen-1300:basis-1/4 screen-1100:basis-1/3 screen-850:basis-1/2 screen-700:basis-full"
                  >
                    <ApartsmentLayoutsItem
                      key={apartment.title}
                      apartment={apartment}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="border-plt-secondary " />
              <CarouselNext className="border-plt-secondary" />
            </Carousel>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
